import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";

function InputSelectIp({
    idIp,
    setIdIp,
    estadoFiltro = null, // string "DISPONIBLE", "OCUPADA" , o un array {["DISPONIBLE","OCUPADA"]}  o null (todas las ip)
    label = "IP"
}) {

    const [ips, setIps] = useState([]);
    const { logout } = useGlobal();
    const apiFetch = useApiFetch();

    useEffect(() => {
        const cargarIps = async () => {
            try {
                const data = await apiFetch("consultar_ips.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" }
                }, logout);

                if (Array.isArray(data)) {
                    setIps(data);
                } else if (data.ips && Array.isArray(data.ips)) {
                    setIps(data.ips);
                }
            } catch {
                console.error("Error al cargar IPs");
            }
        };

        cargarIps();
    }, []);

    // Filtrar según el estado a mostrar
    let ipsFiltradas = ips;
    if (estadoFiltro) {
        if (Array.isArray(estadoFiltro)) {
            ipsFiltradas = ips.filter(ipObj => estadoFiltro.includes(ipObj.estado_ip));
        } else {
            ipsFiltradas = ips.filter(ipObj => ipObj.estado_ip === estadoFiltro);
        }
    }

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={idIp !== null && idIp !== undefined ? idIp.toString() : ""}
                onChange={(e) => {
                    const value = e.target.value;
                    setIdIp(value ? parseInt(value, 10) : null);
                }}
            >
                <option value="" disabled>
                    Seleccione una IP
                </option>
                {ipsFiltradas.map(ipObj => (
                    <option key={ipObj.id_ip} value={ipObj.id_ip.toString()}>
                        {ipObj.ip} {/*({ipObj.estado_ip})*/}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default InputSelectIp;